import { render } from "./IttiHome.vue?vue&type=template&id=017890b8&scoped=true"
import script from "./IttiHome.vue?vue&type=script&lang=js"
export * from "./IttiHome.vue?vue&type=script&lang=js"

import "./IttiHome.vue?vue&type=style&index=0&id=017890b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017890b8"]])

export default __exports__